import { gql } from "@apollo/client";
import { AIMessageFragments } from "AppComponents/GPTPlayground/modules/GPTPlaygroundFragments";

export const updateAIMessageMutation = gql`
  mutation updateAiMessage($input: UpdateAiMessageInput!) {
    ai {
      updateAiMessage(input: $input) {
        isSuccess
        response {
          ...aiMessageItem
        }
      }
    }
  }
  ${AIMessageFragments.AIMessage}
`;

export const createAIMessageMutation = gql`
  mutation createAiMessage($input: CreateAiMessageInput!) {
    ai {
      createAiMessage(input: $input) {
        isSuccess
        response {
          ...aiMessageItem
        }
      }
    }
  }
  ${AIMessageFragments.AIMessage}
`;

export const deleteAIMessageMutation = gql`
  mutation deleteAiMessage($input: DeleteAiMessageInput!) {
    ai {
      deleteAiMessage(input: $input) {
        isSuccess
      }
    }
  }
`;

export const createAiToolDetailMutation = gql`
  mutation createAiToolDetail($input: CreateAiToolDetailInput!) {
    ai {
      createAiToolDetail(input: $input) {
        isSuccess
        warning
        response {
          id
          name
          description
          schema
          toolHandler
          version
          displaySequence
          createdBy
          createdAt
          updatedAt
        }
      }
    }
  }
`;

export const updateAiToolDetailMutation = gql`
  mutation updateAiToolDetail($input: UpdateAiToolDetailInput!) {
    ai {
      updateAiToolDetail(input: $input) {
        isSuccess
        warning
        response {
          id
          name
          description
          schema
          toolHandler
          version
          displaySequence
          updatedAt
        }
      }
    }
  }
`;

export const createBulkAiMessagesMutation = gql`
  mutation createBulkAiMessages($input: CreateBulkAiMessagesInput!) {
    ai {
      createBulkAiMessages(input: $input) {
        isSuccess
        response {
          ...aiMessageItem
        }
      }
    }
  }
  ${AIMessageFragments.AIMessage}
`;
